import React from 'react';
import PropTypes from 'prop-types';
import ConsentBanner from './ConsentBanner';

import Header from './header';

// Import consent debugger in development
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  import('../utils/consentDebugger').then(module => {
    window.ConsentDebugger = module.default;
    console.log('🔧 Consent Debugger loaded. Use window.ConsentDebugger.logConsentState() to debug.');
  });
}

const Layout = ({ children, page }) => (
  <div className='container-fluid'>
    <noscript>
      <iframe 
        src='https://www.googletagmanager.com/ns.html?id=GTM-MHDB9JXG'
        height='0' 
        width='0' 
        style={{display: 'none', visibility: 'hidden'}}
        title='Google Tag Manager'
      />
    </noscript>
    <Header page={page} />
    <main>
      <div id='content-wrapper'>{children}</div>
    </main>
    <footer>© {new Date().getFullYear()} - Dott. Jacopo Biraschi</footer>
    <ConsentBanner />
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
